<template>
  <div>
    <section-header heading="2" ja="X(旧Twitter)アカウントの注意点"/>
    <div class="textArea">
      <p>同じアカウントを複数人で共有している場合、そのX(旧Twitter)アカウントを使って「プリクラON」で認証(ログイン)してしまうと、共有している他の人に登録情報やアルバムなどの個人情報を閲覧される恐れがあります。</p>
      <p>「プリクラON」をX(旧Twitter)アカウントで利用する場合は他の人と共有していないかご確認をお願いいたします。</p>
    </div>
    <sub-btn @click="onAboutWeb()">プリクラONについてに戻る</sub-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import SubBtn from '@/components/SubBtn.vue'

export default {
  name: "AboutWeb01",
  components: {
    SectionHeader,
    SubBtn
  },
  methods: {
    onAboutWeb() {
      this.$router.push("/AppaboutWeb")
    },
  }
}
</script>

<style lang="scss" scoped>
.textArea {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
  p {
    margin-top: 1em;
  }
}
</style>
